/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { mdmsService } from "../../services/mdmsService";
import _ from "lodash";
import { setAccessToken } from "../../services/commerceServices/accessToken";
import { cartMergingCall } from "../../services/commerceServices/cartServices";
import Loader from "../shared-ui/loader";
/**
 * Login Successful component
 *
 * @namespace LoginSuccessful
 */
const LoginSuccessful = () => {
  const history = useHistory();
  const { authState } = useOktaAuth();
  const [isLoading, setIsLoading] = useState(false);
  /**
   * This method is used for handle moved to the same page after successful login
   *
   */

  //  useEffect((): any => {
  //   // This method returns the previous page.
  //   history.go(-2);
  //   // This method is called mdms service to get user info
  //   if (authState && authState.isAuthenticated) {
  //     //mdmsService();
  //     //handleUserInfo();// TODO: Need info from mdms service
  //   }
  // });
  useEffect((): any => {
    console.log("auth--->",authState)
    // Calling mdms service based on login / logout condition
    callMDMSService();
  });

  const callMDMSService = async () => {
    let tokenStorage = localStorage.getItem("okta-token-storage");

    if (authState && authState.isAuthenticated && !authState.isPending && !_.isNull(tokenStorage)) {
    if(!isLoading && !localStorage.getObj("isAuthCalled")){
      let privousRoutePath = localStorage.getItem("previousPath") || '/home';
      setIsLoading(true);
      localStorage.setObj("isAuthCalled",true);
      // history.push(`${privousRoutePath}`);
      await mdmsService().then(async (res: any) => {
        setIsLoading(false);
        // history.go(-2);
      history.push(`${privousRoutePath}`);
        // if (res?.status === 200 || res?.data?.updateRecoUserId?.status === 200) {
        //   // let uuid = localStorage.getItem("cartId") || ""
        //   // await setAccessToken();
        //   // await cartMergingCall(uuid);
        //   // alert("cart call")

        //   history.go(-2);
        // } else {
        //   // send to login :TODO
        //   // alert("history" + JSON.stringify(history));
        //   // condition for silent mdms fail -- TODO verify
        //   // if (history.location.pathname === "/loginsuccessful" && history.length === 3) {
        //   //   history.go(-1);
        //   // } else {
        //   //   history.go(-2);
        //   // }
        // }
      }
      )
    }
    } else if (authState && !authState.isAuthenticated && authState.isPending && _.isNull(tokenStorage)) {
      //history.go(-2);
      let privousRoutePath = localStorage.getItem("previousPath") || '/home';
      if( localStorage.getItem("previousPath")){
        history.push(`${privousRoutePath}`);
      }else{
        history.go(-2);
      }       
    }
  }

  return (
    <div>
      {isLoading ? <Loader loaderClassName={"loader-wrapper align-middle"} />
        : null}
    </div>)
};


export default LoginSuccessful;
